import Skeleton from "@material-ui/lab/Skeleton";

export const RectSkeleton: React.FC = ({ ...props }) => (
  <Skeleton variant="rect" {...props} />
);
